import React from "react";
import ProfileLayout from "../profileLayout";

import { useApiContext } from "@/setup/flexbiz-api-provider";
import { Text, Title } from "@mantine/core";
// import { FiChevronLeft } from "@react-icons/all-files/bs/BsChevronLeft";
import { FiChevronLeft } from "@react-icons/all-files/fi/FiChevronLeft";
import { useRouter } from "next/router";
import useWindowSize from "../../../hooks/useWindowSize";
import NotiList from "./components/NotificationList";

export default function Notifycations() {
  const { isTablet } = useWindowSize();
  const context = useApiContext();
  const router = useRouter();
  React.useEffect(() => {
    if (!localStorage.getItem("token")) {
      context.setProgressStatus(false);
      router.push({ pathname: "/dang-nhap" });
    }
  }, [context]);

  return (
    <>
      {!isTablet ? (
        <ProfileLayout>{/* <NotiList></NotiList> */}</ProfileLayout>
      ) : (
        <div style={{ padding: 20 }}>
          <div style={{ display: "flex", width: "100%", padding: 5 }}>
            <FiChevronLeft
              size={30}
              onClick={() => router.push("/user-profile")}
            />
            <Text align="center" size="lg" sx={{ width: "100%" }}>
              Sổ địa chỉ
            </Text>
          </div>
          {/* <NotiList></NotiList> */}
        </div>
      )}
    </>
  );
}
